/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IAPPRODUCTCONFIGURATIONCODE } from './IAPPRODUCTCONFIGURATIONCODE';
import {
    IAPPRODUCTCONFIGURATIONCODEFromJSON,
    IAPPRODUCTCONFIGURATIONCODEFromJSONTyped,
    IAPPRODUCTCONFIGURATIONCODEToJSON,
} from './IAPPRODUCTCONFIGURATIONCODE';
import type { IAPPRODUCTTYPE } from './IAPPRODUCTTYPE';
import {
    IAPPRODUCTTYPEFromJSON,
    IAPPRODUCTTYPEFromJSONTyped,
    IAPPRODUCTTYPEToJSON,
} from './IAPPRODUCTTYPE';

/**
 * 
 * @export
 * @interface ProductSelectionProductViewModel
 */
export interface ProductSelectionProductViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionProductViewModel
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionProductViewModel
     */
    productConfigurationId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSelectionProductViewModel
     */
    productCodeId?: number;
    /**
     * 
     * @type {IAPPRODUCTCONFIGURATIONCODE}
     * @memberof ProductSelectionProductViewModel
     */
    productConfigurationCode?: IAPPRODUCTCONFIGURATIONCODE;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof ProductSelectionProductViewModel
     */
    productCode?: IAPPRODUCTCODE;
    /**
     * 
     * @type {IAPPRODUCTTYPE}
     * @memberof ProductSelectionProductViewModel
     */
    productType: IAPPRODUCTTYPE;
}

/**
 * Check if a given object implements the ProductSelectionProductViewModel interface.
 */
export function instanceOfProductSelectionProductViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productType" in value;

    return isInstance;
}

export function ProductSelectionProductViewModelFromJSON(json: any): ProductSelectionProductViewModel {
    return ProductSelectionProductViewModelFromJSONTyped(json, false);
}

export function ProductSelectionProductViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSelectionProductViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': !exists(json, 'ProductId') ? undefined : json['ProductId'],
        'productConfigurationId': !exists(json, 'ProductConfigurationId') ? undefined : json['ProductConfigurationId'],
        'productCodeId': !exists(json, 'ProductCodeId') ? undefined : json['ProductCodeId'],
        'productConfigurationCode': !exists(json, 'ProductConfigurationCode') ? undefined : IAPPRODUCTCONFIGURATIONCODEFromJSON(json['ProductConfigurationCode']),
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'productType': IAPPRODUCTTYPEFromJSON(json['ProductType']),
    };
}

export function ProductSelectionProductViewModelToJSON(value?: ProductSelectionProductViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductId': value.productId,
        'ProductConfigurationId': value.productConfigurationId,
        'ProductCodeId': value.productCodeId,
        'ProductConfigurationCode': IAPPRODUCTCONFIGURATIONCODEToJSON(value.productConfigurationCode),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'ProductType': IAPPRODUCTTYPEToJSON(value.productType),
    };
}

